import React from 'react';
import { gettext } from '@eventbrite/i18n';

import { PlatterGraphic } from '@eventbrite/eds-iconography';
import { ChangesGraphic } from '@eventbrite/eds-iconography';
import { CopyGraphic } from '@eventbrite/eds-iconography';

export default {
    packageSelectionPrompt: {
        heading: gettext(
            'Eventbrite now offers tailored packages to better meet your needs.',
        ),
        secondaryHeading: gettext(
            'Select a package before creating your next event.',
        ),
        primaryCTA: gettext('Select Package'),
        graphic: <PlatterGraphic />,
        graphicSize: 'medium',
        dataAutomationTag: 'assortments-create-package',
    },
    nonAdminPrompt: {
        heading: gettext('Create with Eventbrite Professional'),
        secondaryHeading: gettext(
            'In order to create an event you need Eventbrite Professional. We think this is the best fit, but you can contact your Account Owner to change your package at any time.',
        ),
        primaryCTA: gettext('Create Event'),
        graphic: <ChangesGraphic />,
        graphicSize: 'medium',
        dataAutomationTag: 'assortments-nonadmin-screen',
    },
    copyPackageSelectionPrompt: {
        heading: gettext(
            'Eventbrite now offers tailored packages to better meet your needs.',
        ),
        secondaryHeading: gettext(
            'Select a package before creating your next event.',
        ),
        primaryCTA: gettext('Select Package'),
        graphic: <PlatterGraphic />,
        graphicSize: 'medium',
        dataAutomationTag: 'assortments-create-package',
    },
    copyNonAdminPrompt: {
        heading: gettext('Copy with Eventbrite Professional'),
        secondaryHeading: gettext(
            'In order to copy this event you need Eventbrite Professional. We think this is the best fit, but you can contact your Account Owner to change your package at any time.',
        ),
        primaryCTA: gettext('Copy Event'),
        graphic: <CopyGraphic />,
        graphicSize: 'medium',
        dataAutomationTag: 'assortments-nonadmin-screen',
    },
};
